(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-custom-header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerWrapper = document.querySelector('.header-wrapper');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isHomepage = this.headerWrapper.hasAttribute('data-is-homepage');
      this.transparentHomepage = this.headerWrapper.classList.contains('transparent-homepage');
      this.colorScheme = this.headerWrapper.getAttribute('data-color-scheme');

      this.setHeaderHeight();
      this.checkHeroOverlap();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    checkHeroOverlap() {
      const heroSection = document.querySelector('.custom-video[data-overlap-header="true"]');
      if (heroSection) {
        this.headerWrapper.classList.add('has-hero-overlap');
      } else {
        this.headerWrapper.classList.remove('has-hero-overlap');
      }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.headerWrapper.classList.contains('has-hero-overlap')) {
        if (scrollTop > 50) {
          this.headerWrapper.classList.add('scrolled');
          this.headerWrapper.classList.add('color-scheme-1');
          this.headerWrapper.classList.add('gradient');
          this.headerWrapper.style.background = 'var(--gradient-background)';
        } else {
          this.headerWrapper.classList.remove('scrolled');
          this.headerWrapper.classList.remove('color-scheme-1');
          this.headerWrapper.classList.remove('gradient');
          this.headerWrapper.style.background = 'transparent';
        }
      }

      if (scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.headerIsAlwaysSticky) {
          if (scrollTop > this.currentScrollTop) {
            if (this.preventHide) return;
            requestAnimationFrame(this.hide.bind(this));
          } else {
            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);
              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);
              requestAnimationFrame(this.hide.bind(this));
            }
          }
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        if (!this.headerIsAlwaysSticky) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Hamburger menu toggle
  document.addEventListener('DOMContentLoaded', function() {
    const btn = document.querySelector('[data-hamburger-toggle]');
    const dropdown = document.querySelector('[data-hamburger-dropdown]');
    if (!btn || !dropdown) return;

    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      const isOpen = dropdown.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', isOpen);
    });

    document.addEventListener('click', function(e) {
      if (!dropdown.contains(e.target) && !btn.contains(e.target)) {
        dropdown.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-custom-hero"] && !Shopify.designMode) return;
  try {
    
class CustomVideo extends HTMLElement {
  constructor() {
    super();
    this.section = this.querySelector('.custom-video');
    this.wrapper = this;
    this.video = this.querySelector('video');
    this.pauseButton = this.querySelector('.video-pause-button');
    this.mainContent = document.querySelector('main');
    
    if (this.section) {
      this.applyDynamicStyles();
      this.setupEventListeners();
      this.setupVideoControls();
      this.setupHeaderOverlap();
      if (this.dataset.enableSnap === 'true') {
        this.setupScrollSnapping();
      }
    }

    // Listen for theme editor messages
    window.addEventListener('message', (event) => {
      if (event.data.type === 'theme:section:select' || 
          event.data.type === 'shopify:section:select' ||
          event.data.type === 'theme:section:settings' ||
          event.data.type === 'shopify:section:settings') {
        
        // Check if this is our section
        if (event.data.sectionId === this.getAttribute('data-section-id')) {
          // If we have video speed in the settings update
          if (event.data.settings && typeof event.data.settings.video_playback_speed !== 'undefined') {
            const newSpeed = parseFloat(event.data.settings.video_playback_speed);
            if (this.video && !isNaN(newSpeed)) {
              this.video.playbackRate = newSpeed;
              this.video.dataset.speed = newSpeed;
            }
          }
        }
      }
    });
  }

  setupHeaderOverlap() {
    const header = document.querySelector('.header-wrapper');
    if (!header) return;

    const updateOverlap = () => {
      const overlaps = this.wrapper.dataset.overlapHeader === "true";
      const headerHeight = parseInt(this.wrapper.dataset.headerHeightManual || 0);
      
      // Set the header height CSS variable
      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
      
      if (overlaps) {
        // Add transparent class to header
        header.classList.add('header--transparent');
        // Add overlap class to section
        const section = this.closest('.section');
        if (section) {
          section.classList.add('overlap-header');
          section.style.marginTop = `-${headerHeight}px`;
        }
        // Add overlap class to background wrapper and slider
        const backgroundWrapper = this.querySelector('.custom-video__background-wrapper');
        const slider = this.querySelector('.custom-video__slider');
        
        if (backgroundWrapper) {
          backgroundWrapper.classList.add('overlap-header');
        }
        if (slider) {
          slider.classList.add('overlap-header');
        }
      } else {
        // Remove transparent class from header
        header.classList.remove('header--transparent');
        // Remove overlap class from section
        const section = this.closest('.section');
        if (section) {
          section.classList.remove('overlap-header');
          section.style.marginTop = '';
        }
        // Remove overlap class from background wrapper and slider
        const backgroundWrapper = this.querySelector('.custom-video__background-wrapper');
        const slider = this.querySelector('.custom-video__slider');
        
        if (backgroundWrapper) {
          backgroundWrapper.classList.remove('overlap-header');
        }
        if (slider) {
          slider.classList.remove('overlap-header');
        }
      }
    };

    // Initial setup
    updateOverlap();

    // Update on resize
    window.addEventListener('resize', updateOverlap);

    // Update when header changes
    const observer = new MutationObserver(updateOverlap);
    observer.observe(header, { attributes: true, attributeFilter: ['class'] });
  }

  setupScrollSnapping() {
    const snapContainer = document.querySelector('.custom-video-wrapper');
    if (!snapContainer) return;

    let isScrolling = false;
    let startX, startY;

    const startScroll = (e) => {
      if (e.target.closest('a, button')) return;
      e.preventDefault();
      isScrolling = true;
      startX = e.pageX;
      startY = e.pageY;
    };

    const scroll = (e) => {
      if (!isScrolling) return;
      const dx = e.pageX - startX;
      const dy = e.pageY - startY;
      if (Math.abs(dx) > Math.abs(dy)) {
        e.preventDefault();
        snapContainer.scrollLeft += dx;
      }
    };

    const endScroll = () => {
      isScrolling = false;
    };

    snapContainer.addEventListener('mousedown', startScroll);
    snapContainer.addEventListener('mousemove', scroll);
    snapContainer.addEventListener('mouseup', endScroll);
    snapContainer.addEventListener('touchstart', startScroll);
    snapContainer.addEventListener('touchmove', scroll);
    snapContainer.addEventListener('touchend', endScroll);
  }

  setupVideoControls() {
    if (this.pauseButton) {
      this.pauseButton.addEventListener('click', () => {
        if (this.video.paused) {
          this.video.play();
        } else {
          this.video.pause();
        }
      });
    }
  }

  applyDynamicStyles() {
    const style = getComputedStyle(this);
    this.style.setProperty('--color-button', style.getPropertyValue('--parent-button-color'));
    this.style.setProperty('--color-button-text', style.getPropertyValue('--parent-button-text-color'));
    this.style.setProperty('--color-foreground', style.getPropertyValue('--parent-foreground-color'));
    this.style.setProperty('--buttons-radius', style.getPropertyValue('--border-radius'));
  }

  setupEventListeners() {
    // Add transition for main content
    if (this.mainContent) {
      this.mainContent.style.transition = 'transform 0.5s ease';
    }

    // Listen for slide changes
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const target = mutation.target;
          if (target.classList.contains('custom-video__slide')) {
            this.updateMainContentPosition(target);
          }
        }
      });
    });

    // Observe all slides
    const slides = this.querySelectorAll('.custom-video__slide');
    slides.forEach(slide => {
      observer.observe(slide, { attributes: true });
    });
  }

  updateMainContentPosition(activeSlide) {
    if (!this.mainContent) return;

    const slideHeight = this.section.offsetHeight;
    const slideIndex = Array.from(this.querySelectorAll('.custom-video__slide')).indexOf(activeSlide);
    
    // Calculate the transform value based on the slide index
    const transformValue = `translateY(-${slideIndex * slideHeight}px)`;
    
    // Apply the transform to the main content
    this.mainContent.style.transform = transformValue;
  }
}

customElements.define('custom-video-section', CustomVideo);

class ImageSlider {
  constructor(container) {
    this.container = container;
    // Clear early autoplay interval if it was running
    if (container.dataset.earlyInterval) {
      clearInterval(parseInt(container.dataset.earlyInterval));
      container.dataset.sliderTaken = 'true';
    }
    this.slides = Array.from(container.querySelectorAll('.custom-video__slide'));
    this.dots = Array.from(container.querySelectorAll('.custom-video__slider-dot'));
    this.prevButton = container.querySelector('.custom-video__slider-button.prev');
    this.nextButton = container.querySelector('.custom-video__slider-button.next');
    // Pick up current active slide index (may have been advanced by early autoplay)
    var activeIdx = 0;
    this.slides.forEach(function(s, i) { if (s.classList.contains('active')) activeIdx = i; });
    this.currentIndex = activeIdx;
    this.isAutoplay = container.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(container.dataset.autoplaySpeed) || 5000;
    this.autoplayInterval = null;
    this.isTransitioning = false;
    this.isMobile = window.innerWidth <= 749;

    // Ensure slider maintains parent height
    this.maintainHeight();

    // Enable slide transitions after first paint (prevents flash on load)
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.container.classList.add('slider-ready');
      });
    });

    // Initialize slider on desktop normally
    if (!this.isMobile) {
      this.init();
    } else {
      // On mobile: use simple opacity cycling without touching layout
      this.initMobileAutoplay();
    }

    // Listen for window resize to handle mobile/desktop transitions
    window.addEventListener('resize', () => {
      const wasMobile = this.isMobile;
      this.isMobile = window.innerWidth <= 749;

      // If transitioning from desktop to mobile
      if (!wasMobile && this.isMobile) {
        this.stopAutoplay();
        this.initMobileAutoplay();
      }
      // If transitioning from mobile to desktop
      else if (wasMobile && !this.isMobile) {
        this.slides.forEach(slide => {
          slide.style.display = '';
        });
        this.init();
      }
    });
  }

  maintainHeight() {
    const parent = this.container.closest('.custom-video');
    if (!parent) return;

    // Get the height class from parent
    const heightClass = Array.from(parent.classList).find(cls => cls.startsWith('custom-video-'));
    if (!heightClass) return;

    // Get the header height
    const header = document.querySelector('.header-wrapper');
    const announcement = document.querySelector('.announcement-bar');
    const headerHeight = header ? header.offsetHeight : 0;
    const announcementHeight = announcement ? announcement.offsetHeight : 0;
    const totalOffset = headerHeight + announcementHeight;

    // Apply the same height to all slides
    this.slides.forEach(slide => {
      slide.style.height = '100%';
      const slideImage = slide.querySelector('.custom-video__slide-image');
      if (slideImage) {
        slideImage.style.height = '100%';
      }
    });

    // Handle mobile height
    if (this.isMobile) {
      const heightMap = {
        'custom-video-full': `calc(100vh - ${totalOffset}px)`,
        'custom-video-five-sixths': `calc(83.33vh - ${totalOffset}px)`,
        'custom-video-four-fifths': `calc(80vh - ${totalOffset}px)`,
        'custom-video-three-quarters': `calc(75vh - ${totalOffset}px)`,
        'custom-video-two-thirds': `calc(66.66vh - ${totalOffset}px)`,
        'custom-video-half': `calc(50vh - ${totalOffset}px)`,
        'custom-video-one-third': `calc(33.33vh - ${totalOffset}px)`
      };

      const customHeight = parent.dataset.customHeight;
      if (heightClass === 'custom-video-custom' && customHeight) {
        parent.style.height = `calc(${customHeight}vh - ${totalOffset}px)`;
      } else if (heightMap[heightClass]) {
        parent.style.height = heightMap[heightClass];
      }
    }
  }

  init() {
    if (this.slides.length <= 1) return;

    // Remove active class from all slides except first
    this.slides.forEach((slide, index) => {
      if (index !== 0) {
        slide.classList.remove('active');
      }
    });

    // Setup navigation
    if (this.prevButton && this.nextButton) {
      this.prevButton.addEventListener('click', () => this.navigate('prev'));
      this.nextButton.addEventListener('click', () => this.navigate('next'));
    }

    // Setup dots
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.goToSlide(index));
    });

    // Setup autoplay
    if (this.isAutoplay) {
      this.startAutoplay();
    }

    // Touch events
    let touchStartX = 0;
    let touchEndX = 0;

    this.container.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].clientX;
      this.stopAutoplay();
    });

    this.container.addEventListener('touchmove', (e) => {
      touchEndX = e.touches[0].clientX;
    });

    this.container.addEventListener('touchend', () => {
      const difference = touchStartX - touchEndX;
      if (Math.abs(difference) > 50) {
        if (difference > 0) {
          this.navigate('next');
        } else {
          this.navigate('prev');
        }
      }
      if (this.isAutoplay) this.startAutoplay();
    });
  }

  navigate(direction) {
    const slides = this.slides;
    const currentIndex = this.currentIndex;
    const totalSlides = slides.length;

    if (direction === 'prev') {
      this.currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;
    } else if (direction === 'next') {
      this.currentIndex = (currentIndex + 1) % totalSlides;
    }

    slides.forEach((slide, index) => {
      if (index === this.currentIndex) {
        slide.classList.add('active');
      } else {
        slide.classList.remove('active');
      }
    });
  }

  initMobileAutoplay() {
    if (this.slides.length <= 1 || !this.isAutoplay) return;
    // On mobile, all slides are already position:absolute with opacity transitions via CSS
    // Just cycle the 'active' class without touching display/layout
    this.slides.forEach((slide, index) => {
      // Don't set display:none — let CSS handle visibility via opacity
      slide.style.display = '';
      if (index !== 0) {
        slide.classList.remove('active');
      }
    });
    this.currentIndex = 0;
    this.mobileInterval = setInterval(() => {
      this.slides[this.currentIndex].classList.remove('active');
      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
      this.slides[this.currentIndex].classList.add('active');
    }, this.autoplaySpeed);
  }

  startAutoplay() {
    if (this.autoplayInterval) return;
    this.autoplayInterval = setInterval(() => this.navigate('next'), this.autoplaySpeed);
  }

  stopAutoplay() {
    clearInterval(this.autoplayInterval);
    this.autoplayInterval = null;
  }

  goToSlide(index) {
    this.currentIndex = index;
    this.navigate('next');
  }
}

/* Initialize image slider */
(function() {
  var sliderEl = document.querySelector('.custom-video__slider');
  if (sliderEl && sliderEl.querySelectorAll('.custom-video__slide').length > 1) {
    new ImageSlider(sliderEl);
  }
})();

(function() {
  function setHeroHeight() {
    var hero = document.querySelector('.custom-video[data-hero-dynamic]');
    if (!hero) return;
    
    var isMobile = window.innerWidth <= 749;
    var overlap = isMobile ? false : hero.dataset.overlapHeader === "true";
    var isFull = hero.classList.contains('custom-video-full');
    var isFiveSixths = hero.classList.contains('custom-video-five-sixths');
    var isFourFifths = hero.classList.contains('custom-video-four-fifths');
    var isThreeQuarters = hero.classList.contains('custom-video-three-quarters');
    var isTwoThirds = hero.classList.contains('custom-video-two-thirds');
    var isHalf = hero.classList.contains('custom-video-half');
    var isOneThird = hero.classList.contains('custom-video-one-third');
    var isCustom = hero.classList.contains('custom-video-custom');
    
    var header = document.querySelector('.header-wrapper');
    var announcement = document.querySelector('.announcement-bar');
    var headerHeight = parseInt(hero.dataset.headerHeightManual) || (header ? header.offsetHeight : 0);
    var announcementHeight = announcement ? announcement.offsetHeight : 0;
    var totalOffset = headerHeight + announcementHeight;
    
    // Set CSS variables for use in other styles
    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
    document.documentElement.style.setProperty('--announcement-height', `${announcementHeight}px`);
    
    // Remove any existing height styles first
    hero.style.removeProperty('height');
    hero.style.removeProperty('margin-top');

    // Handle overlap-header class
    if (isMobile) {
      hero.classList.remove('overlap-header');
    } else if (overlap) {
      hero.classList.add('overlap-header');
    } else {
      hero.classList.remove('overlap-header');
    }
    
    if (overlap) {
      // When overlapping, set negative margin to pull the hero up by total offset
      hero.style.marginTop = `-${totalOffset}px`;
      
      // Calculate height based on the section's height class and add total offset
      if (isFull) {
        hero.style.setProperty('height', `calc(100vh + ${totalOffset}px)`, 'important');
      } else if (isFiveSixths) {
        hero.style.setProperty('height', `calc(83.33vh + ${totalOffset}px)`, 'important');
      } else if (isFourFifths) {
        hero.style.setProperty('height', `calc(80vh + ${totalOffset}px)`, 'important');
      } else if (isThreeQuarters) {
        hero.style.setProperty('height', `calc(75vh + ${totalOffset}px)`, 'important');
      } else if (isTwoThirds) {
        hero.style.setProperty('height', `calc(66.66vh + ${totalOffset}px)`, 'important');
      } else if (isHalf) {
        hero.style.setProperty('height', `calc(50vh + ${totalOffset}px)`, 'important');
      } else if (isOneThird) {
        hero.style.setProperty('height', `calc(33.33vh + ${totalOffset}px)`, 'important');
      } else if (isCustom) {
        var customHeight = parseInt(hero.dataset.customHeight) || 50;
        hero.style.setProperty('height', `calc(${customHeight}vh + ${totalOffset}px)`, 'important');
      }
    } else {
      hero.style.marginTop = '0';
      
      // Calculate height based on the section's height class
      if (isFull) {
        hero.style.setProperty('height', `calc(100vh - ${totalOffset}px)`, 'important');
      } else if (isFiveSixths) {
        hero.style.setProperty('height', `calc(83.33vh - ${totalOffset}px)`, 'important');
      } else if (isFourFifths) {
        hero.style.setProperty('height', `calc(80vh - ${totalOffset}px)`, 'important');
      } else if (isThreeQuarters) {
        hero.style.setProperty('height', `calc(75vh - ${totalOffset}px)`, 'important');
      } else if (isTwoThirds) {
        hero.style.setProperty('height', `calc(66.66vh - ${totalOffset}px)`, 'important');
      } else if (isHalf) {
        hero.style.setProperty('height', `calc(50vh - ${totalOffset}px)`, 'important');
      } else if (isOneThird) {
        hero.style.setProperty('height', `calc(33.33vh - ${totalOffset}px)`, 'important');
      } else if (isCustom) {
        var customHeight = parseInt(hero.dataset.customHeight) || 50;
        hero.style.setProperty('height', `calc(${customHeight}vh - ${totalOffset}px)`, 'important');
      }
    }
  }
  
  // Run on load and resize
  document.addEventListener('DOMContentLoaded', setHeroHeight);
  window.addEventListener('resize', setHeroHeight);
  
  // Also run when the section is loaded in the theme editor
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('.custom-video[data-hero-dynamic]')) {
      setHeroHeight();
    }
  });

  // Run when section settings are updated
  document.addEventListener('shopify:section:settings', function(event) {
    if (event.target.querySelector('.custom-video[data-hero-dynamic]')) {
      setHeroHeight();
    }
  });
})();

/* Fix: ensure anchor links inside hero work on mobile + clean up hash so
   page doesn't auto-scroll to anchor on reload */
(function() {
  function smoothScrollTo(hash, e) {
    var target = document.getElementById(hash);
    if (target) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      var offset = window.innerWidth <= 749 ? 115 : 160;
      var y = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: y, behavior: 'smooth' });
      /* Remove hash from URL so reload doesn't auto-scroll */
      setTimeout(function() {
        history.replaceState(null, '', window.location.pathname);
      }, 100);
    }
  }

  document.querySelectorAll('.custom-video__slide a[href*="#"], .custom-hero__buttons a[href*="#"]').forEach(function(link) {
    link.addEventListener('touchend', function(e) {
      var href = this.getAttribute('href');
      var hash = href.indexOf('#') !== -1 ? href.split('#')[1] : null;
      if (hash) smoothScrollTo(hash, e);
    });
    link.addEventListener('click', function(e) {
      var href = this.getAttribute('href');
      var hash = href.indexOf('#') !== -1 ? href.split('#')[1] : null;
      if (hash) smoothScrollTo(hash, e);
    });
  });

  /* If page loads with a #bundle hash, scroll to top instead */
  if (window.location.hash && window.location.hash.indexOf('bundle') !== -1) {
    window.scrollTo(0, 0);
    history.replaceState(null, '', window.location.pathname);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-custom-video-image"] && !Shopify.designMode) return;
  try {
    
class CustomVideo extends HTMLElement {
  constructor() {
    super();
    this.section = this.querySelector('.custom-video');
    this.wrapper = this;
    this.video = this.querySelector('video');
    this.pauseButton = this.querySelector('.video-pause-button');
    
    if (this.section) {
      this.applyDynamicStyles();
      this.setupEventListeners();
      this.setupVideoControls();
      if (this.dataset.enableSnap === 'true') {
        this.setupScrollSnapping();
      }
    }

    // Listen for theme editor messages
    window.addEventListener('message', (event) => {
      if (event.data.type === 'theme:section:select' || 
          event.data.type === 'shopify:section:select' ||
          event.data.type === 'theme:section:settings' ||
          event.data.type === 'shopify:section:settings') {
        
        // Check if this is our section
        if (event.data.sectionId === this.getAttribute('data-section-id')) {
          // If we have video speed in the settings update
          if (event.data.settings && typeof event.data.settings.video_playback_speed !== 'undefined') {
            const newSpeed = parseFloat(event.data.settings.video_playback_speed);
            if (this.video && !isNaN(newSpeed)) {
              this.video.playbackRate = newSpeed;
              this.video.dataset.speed = newSpeed;
            }
          }
        }
      }
    });
  }

  applyDynamicStyles() {
    const manual = parseInt(this.section.dataset.headerHeightManual || 0);
    const slider = parseInt(this.section.dataset.headerHeight || 0);
    const height = manual > 0 ? manual : slider;
    const overlaps = this.section.dataset.overlapHeader === "true";

    if (overlaps) {
      this.section.classList.add('overlap-header');
      this.section.style.zIndex = '0';
    } else {
      this.section.classList.remove('overlap-header');
      this.section.style.zIndex = '';
    }

    if (this.section.classList.contains('custom-video-full')) {
      const vh = window.innerHeight;
      this.section.style.height = `${vh}px`;
    }

    const headingEl = this.section.querySelector('.custom-video__heading');
    const subtextEl = this.section.querySelector('.custom-video__subtext');

    if (headingEl) headingEl.style.fontSize = `${this.section.dataset.headingSize}px`;
    if (subtextEl) subtextEl.style.fontSize = `${this.section.dataset.subtextSize}px`;
  }

  setupEventListeners() {
    window.addEventListener('resize', this.applyDynamicStyles.bind(this));
    document.addEventListener('shopify:section:load', this.applyDynamicStyles.bind(this));
    document.addEventListener('shopify:section:select', this.applyDynamicStyles.bind(this));
    document.addEventListener('shopify:section:deselect', this.applyDynamicStyles.bind(this));
    document.addEventListener('shopify:block:select', this.applyDynamicStyles.bind(this));
    document.addEventListener('shopify:block:deselect', this.applyDynamicStyles.bind(this));
  }

  setupScrollSnapping() {
    if (this.dataset.enableSnap !== 'true') return;

    let lastScrollTime = 0;
    const scrollCooldown = 500;

    this.wheelHandler = (e) => {
      const now = Date.now();
      if (now - lastScrollTime < scrollCooldown) {
        e.preventDefault();
        return;
      }

      const rect = this.getBoundingClientRect();
      const visibleRatio = Math.abs(rect.top) < window.innerHeight / 2;

      if (visibleRatio) {
        const direction = e.deltaY > 0 ? 1 : -1;
        const nextSection = this.findNextScrollTarget(direction);
        
        if (nextSection) {
          e.preventDefault();
          nextSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
          lastScrollTime = now;
        }
      }
    };

    window.addEventListener('wheel', this.wheelHandler, { passive: false });
  }

  findNextScrollTarget(direction) {
    const allSections = Array.from(document.querySelectorAll('.custom-video-wrapper'));
    const currentIndex = allSections.indexOf(this);
    
    if (direction > 0) {
      // Looking for next section
      for (let i = currentIndex + 1; i < allSections.length; i++) {
        const section = allSections[i];
        if (section.dataset.enableSnap === 'true') {
          return section;
        }
      }
      // If no next snap section found, return null to allow normal scrolling
      return null;
    } else {
      // Looking for previous section
      for (let i = currentIndex - 1; i >= 0; i--) {
        const section = allSections[i];
        if (section.dataset.enableSnap === 'true') {
          return section;
        }
      }
      // If no previous snap section found, return null to allow normal scrolling
      return null;
    }
  }

  disconnectedCallback() {
    if (this.wheelHandler) {
      window.removeEventListener('wheel', this.wheelHandler);
    }
  }

  setupVideoControls() {
    if (this.video && this.pauseButton) {
      // Set initial playback speed
      const speed = parseFloat(this.video.dataset.speed || "1.0");
      this.video.playbackRate = speed;

      // Handle pause/play button
      this.pauseButton.addEventListener('click', () => {
        if (this.video.paused) {
          this.video.play();
          this.pauseButton.classList.remove('paused');
        } else {
          this.video.pause();
          this.pauseButton.classList.add('paused');
        }
      });

      // Update button state when video naturally ends
      this.video.addEventListener('ended', () => {
        this.pauseButton.classList.add('paused');
      });

      // Ensure speed stays correct after any play event
      this.video.addEventListener('play', () => {
        const currentSpeed = parseFloat(this.video.dataset.speed || "1.0");
        this.video.playbackRate = currentSpeed;
      });
    }
  }
}

customElements.define('custom-video-section', CustomVideo);

// Add this to handle the conditional display of the left image width setting
document.addEventListener('DOMContentLoaded', function() {
  const ratioSelect = document.querySelector('[name="side_image_ratio"]');
  const leftWidthSetting = document.querySelector('.side-image-ratio-custom');
  
  if (ratioSelect && leftWidthSetting) {
    function toggleLeftWidth() {
      if (ratioSelect.value === 'custom') {
        leftWidthSetting.style.display = 'block';
      } else {
        leftWidthSetting.style.display = 'none';
      }
    }

    // Initial state
    toggleLeftWidth();

    // Listen for changes
    ratioSelect.addEventListener('change', toggleLeftWidth);
  }
});

document.addEventListener("DOMContentLoaded", function () {
  // Wait until the video elements are loaded
  setTimeout(() => {
    // Select all video elements inside the section
    const videos = document.querySelectorAll(".custom-video__background");

    if (videos.length === 0) {
      console.warn("No videos found in the section.");
      return;
    }

    videos.forEach(video => {
      // Get video speed from data attribute
      const videoSpeed = parseFloat(video.dataset.speed || "1.0");

      if (video.readyState >= 2) {
        video.playbackRate = videoSpeed;
      } else {
        video.addEventListener("loadeddata", function () {
          video.playbackRate = videoSpeed;
        });
      }

      // Ensure speed stays correct even if autoplay restarts
      video.addEventListener("play", function () {
        video.playbackRate = videoSpeed;
      });

      // Handle pause/play button
      const pauseButton = video.nextElementSibling;
      if (pauseButton && pauseButton.classList.contains('video-pause-button')) {
        pauseButton.addEventListener('click', () => {
          if (video.paused) {
            video.play();
            pauseButton.classList.remove('paused');
          } else {
            video.pause();
            pauseButton.classList.add('paused');
          }
        });

        // Update button state when video naturally ends
        video.addEventListener('ended', () => {
          pauseButton.classList.add('paused');
        });
      }
    });

    console.log("Video speed set to:", videoSpeed);
  }, 500); // Delay to ensure videos are loaded
});

  } catch(e) { console.error(e); }
})();
})();
